// @flow

export const LOGOUT = 'LOGOUT';
export const SET_USER = 'SET_USER';

export const REFRESH_USER_REQUEST = 'REFRESH_USER_REQUEST';
export const REFRESH_USER_SUCCESS = 'REFRESH_USER_SUCCESS';
export const REFRESH_USER_ERROR = 'REFRESH_USER_ERROR';

export const FETCH_RECORDINGS_REQUEST = 'FETCH_RECORDINGS_REQUEST';
export const FETCH_RECORDINGS_SUCCESS = 'FETCH_RECORDINGS_SUCCESS';
export const FETCH_RECORDINGS_ERROR = 'FETCH_RECORDINGS_ERROR';

export const FETCH_LOCATIONS_REQUEST = 'FETCH_LOCATIONS_REQUEST';
export const FETCH_LOCATIONS_SUCCESS = 'FETCH_LOCATIONS_SUCCESS';
export const FETCH_LOCATIONS_ERROR = 'FETCH_LOCATIONS_ERROR';

export const FETCH_HEATMAPS_REQUEST = 'FETCH_HEATMAPS_REQUEST';
export const FETCH_HEATMAPS_SUCCESS = 'FETCH_HEATMAPS_SUCCESS';
export const FETCH_HEATMAPS_ERROR = 'FETCH_HEATMAPS_ERROR';

export const FETCH_HEATMAP_SOURCE_URL_REQUEST =
  'FETCH_HEATMAP_SOURCE_URL_REQUEST';
export const FETCH_HEATMAP_SOURCE_URL_SUCCESS =
  'FETCH_HEATMAP_SOURCE_URL_SUCCESS';
export const FETCH_HEATMAP_SOURCE_URL_ERROR = 'FETCH_HEATMAP_SOURCE_URL_ERROR';

export const FETCH_QUERY_DATA_REQUEST = 'FETCH_QUERY_DATA_REQUEST';
export const FETCH_QUERY_DATA_SUCCESS = 'FETCH_QUERY_DATA_SUCCESS';
export const FETCH_QUERY_DATA_GENERAL_ERROR = 'FETCH_QUERY_DATA_GENERAL_ERROR';

export const EDIT_PAGE_SETTINGS = 'EDIT_PAGE_SETTINGS';

export const EDIT_SUMMARY_PAGE_ACTIVE_METRICS =
  'EDIT_SUMMARY_PAGE_ACTIVE_METRICS';
export const CLEAR_SUMMARY_PAGE_ACTIVE_METRICS = 'CLEAR_SUMMARY_PAGE_ACTIVE_METRICS';

export const FETCH_QUERY_DATA_METRICS_ERROR = 'FETCH_QUERY_DATA_METRICS_ERROR';
export const CLEAR_QUERY_RESPONSE_LIST = 'CLEAR_QUERY_RESPONSE_LIST';

export const FETCH_REPORTS_REQUEST = 'FETCH_REPORTS_REQUEST';
export const FETCH_REPORTS_SUCCESS = 'FETCH_REPORTS_SUCCESS';
export const FETCH_REPORTS_ERROR = 'FETCH_REPORTS_ERROR';

export const EDIT_LOCATION_SUCCESS = 'EDIT_LOCATION_SUCCESS';
export const EDIT_LOCATION_ERROR = 'EDIT_LOCATION_ERROR';

export const FETCH_CAMPAIGNS_REQUEST = 'FETCH_CAMPAIGNS_REQUEST';
export const FETCH_CAMPAIGNS_SUCCESS = 'FETCH_CAMPAIGNS_SUCCESS';
export const FETCH_CAMPAIGNS_ERROR = 'FETCH_CAMPAIGNS_ERROR';

// AI Chat Thread Actions
export const FETCH_CHAT_THREADS_REQUEST = 'FETCH_CHAT_THREADS_REQUEST';
export const FETCH_CHAT_THREADS_SUCCESS = 'FETCH_CHAT_THREADS_SUCCESS';
export const FETCH_CHAT_THREADS_ERROR = 'FETCH_CHAT_THREADS_ERROR';
export const CLEAR_CHAT_THREADS = 'CLEAR_CHAT_THREADS';
export const UPDATE_CHAT_THREAD_SUCCESS = 'UPDATE_CHAT_THREAD_SUCCESS';

// Location Tagging
export const FETCH_TAGS_REQUEST = 'FETCH_TAGS_REQUEST';
export const FETCH_TAGS_SUCCESS = 'FETCH_TAGS_SUCCESS';
export const FETCH_TAGS_ERROR = 'FETCH_TAGS_ERROR';

export const CREATE_TAG_SUCCESS = 'CREATE_TAG_SUCCESS';
export const UPDATE_TAG_SUCCESS = 'UPDATE_TAG_SUCCESS';
export const DELETE_TAG_SUCCESS = 'DELETE_TAG_SUCCESS';

export const ASSIGN_TAG_TO_LOCATION_SUCCESS = 'ASSIGN_TAG_TO_LOCATION_SUCCESS';
export const REMOVE_TAG_FROM_LOCATION_SUCCESS = 'REMOVE_TAG_FROM_LOCATION_SUCCESS';
export const BULK_ASSIGN_TAGS_SUCCESS = 'BULK_ASSIGN_TAGS_SUCCESS';
export const BULK_REMOVE_TAGS_SUCCESS = 'BULK_REMOVE_TAGS_SUCCESS';

export const HYDRATE_LOCATION_TAGS = 'HYDRATE_LOCATION_TAGS';

// Users slice
export const USERS_FETCH_REQUEST = 'USERS_FETCH_REQUEST';
export const USERS_FETCH_SUCCESS = 'USERS_FETCH_SUCCESS';
export const USERS_FETCH_ERROR = 'USERS_FETCH_ERROR';

export const USER_ROLE_ADDED = 'USER_ROLE_ADDED';
export const USER_ROLE_REMOVED = 'USER_ROLE_REMOVED';

export const USER_PREFERENCE_CREATED = 'USER_PREFERENCE_CREATED';
export const USER_PREFERENCE_UPDATED = 'USER_PREFERENCE_UPDATED';
export const USER_PREFERENCE_DELETED = 'USER_PREFERENCE_DELETED';

export const USER_REMOVED = 'USER_REMOVED';
export const USERS_RESET = 'USERS_RESET';